import { Icon } from 'components/icon';

import { useGoogleAuth } from 'services/hooks/use-google-auth';

import { StyledIcon } from 'components/social-auth/social-auth.styles';

export const GoogleButton = () => {
  const { startGoogleAuth } = useGoogleAuth();

  return (
    <StyledIcon
      role="button"
      tabIndex={0}
      aria-label="Sign in with Google"
      onClick={startGoogleAuth}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          startGoogleAuth();
        }
      }}
    >
      <Icon type="googleLogin" />
    </StyledIcon>
  );
};
